import { Box } from '@mui/material'

const HeroSection = () => {
	return <Box className='-cdp-home-hero' style={{ backgroundImage: "url('/image/your-story-matters-2.jpg')" }}></Box>
}

export default HeroSection
